export default "__VITE_ASSET__703e86de__"